<template>
  <div>
    <section class="container">
      <div class="columns is-multiline">
        <div class="column is-three-fifths is-offset-one-fifth">
          <div class="notification">
            <router-link to="/">
              <div class="logo"></div>
            </router-link>
            <h2 class="title is-4 has-text-primary">Reset Password</h2>
            <p class="info-text">Enter the email you use for your DOT Training Solutions account.</p>
            <form @submit.prevent="submit">
              <div class="field"></div>
              <div class="control">
                <!--vuelidate-->
                <input
                  class="input is-medium"
                  type="email"
                  placeholder="Email"
                  v-model.trim="$v.form.email.$model"
                  :class="{'is-danger' :$v.form.email.$error}"
                />

                <div class="error" v-if="$v.form.email.$error">Email is required</div>
              </div>
              <b-button
                native-type="submit"
                class="button is-block is-fullwidth is-medium"
                :class="[$v.form.email.$invalid ? 'disabled' : 'is-primary']"
              >Submit</b-button>
              <br />
              <router-link to="/login"><small>Back to login.</small></router-link>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import AuthService from '../services/auth.service'

export default {
  name: 'ForgotPassword',
  data() {
    return {
      form: {
        email: '',
      },
    }
  },
  methods: {
    submit() {
      if (!this.$v.form.email.$invalid) {
        console.log('submitting forgot password form...')
        AuthService.forgotPassword(this.form)
          .then(response => {
            console.log(
              'forgot pass response: ' + JSON.stringify(response.data)
            )
            this.$router.push('/login')
          })
          .catch(error => {
            console.log('forget pass error: ' + error.response)
          })
      }
    },
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../theme.scss';

:root {
  --brandColor: $primary;
  --background: rgb(247, 247, 247);
  --textDark: hsla(0, 0%, 0%, 0.66);
  --textLight: hsla(0, 0%, 0%, 0.33);
}

.logo {
  background-image: url('~@/assets/logo.png');
  width: 250px;
  height: 150px;
  background-size: cover;
  margin-bottom: 25px;
  margin-left: auto;
  margin-right: auto;
}

.notification {
  margin: 5rem;
  background: white;
}

.title {
  text-align: center;
}

.button,
.input {
  margin: 0.5rem;
}

.error,
.info-text {
  margin-left: 0.5rem;
}

.disabled {
  cursor: not-allowed;
}
</style>